import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function EmailNotVerified() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream to-white px-6">
      <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-md text-center border border-primary/10">
        <AlertTriangle size={70} className="text-yellow-500 mx-auto mb-6" />
        <h1 className="text-3xl font-extrabold text-primary mb-3">
          Verify Your Email
        </h1>
        <p className="text-dark/70 text-sm mb-8">
          You need to verify your email before logging in. Please check your inbox.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary/90 transition"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}
